/* eslint-disable sonarjs/cognitive-complexity */
import { BaSeDataTable, BaSeTheme } from '@base/react';

import React from 'react';
import { useInterviewService } from '../../../../hooks/services/interview-service';
import RvaliableRuralCandidate from '../../components/avaliable-rural-candidate/avaliable-rural-candidate';
import CommonTable from '../../components/data-table/common-table';
import RuralTable from '../../components/data-table/rural-table';
import { useTableInterview } from '../../context/table-interview-context';
import { AvaliableRuralContext } from './context/avaliable-rural-candidate';
import AvaliarQuestionario from './form-avaliar-questionario/avaliar-questionario';
import VisualizarNotasRespostas from './visualizar-notas-respostas';


const MainContent = ({
  showNotas,
  showAvaliableCandidate,
  cpfSearched,
  notasRespostas,
  respostas,
  setShowNotas,
  setShowAvaliableCandidate,
  respostasQuestionarioStartup,
  configTable,
  columnConfig,
  cache,
  cacheKeySebrae,
  hasCustomFilter,
  cacheKey,
  clear,
  getSelectionIconActions,
  buildCustomFilter,
  getSelectionButtonActions,
  hasApprove,
  setHasApprove,
  setItemsSelectTable,
  setIsAllSelect,
  textFilter,
  moduleSelected,
  settingsMap,
  dataToAvaliationRural,
}) => {
  const { fetchData, data, loading, clearAll } = useInterviewService();

  const { fetchData: loadSEarchInterview, data: dataSearchInterview, loading: loadingSearch, clearAll: clearSearchInterview } = useTableInterview();



  const { showAvaliableRuralCandidate } = React.useContext(
    AvaliableRuralContext,
  );

  if (showAvaliableRuralCandidate) {
    return (
      <RvaliableRuralCandidate
        settingsMap={settingsMap}
        fetchData={fetchData}
      />
    );
  }
  if (showNotas) {
    return (
      <VisualizarNotasRespostas
        notasRespostas={notasRespostas}
        respostas={respostas}
        setShowNotas={setShowNotas}
        codigo={1}
        fetchData={fetchData}
      />
    );
  }

  if (showAvaliableCandidate) {
    return (
      <AvaliarQuestionario
        hasApprove={hasApprove}
        setHasApprove={setHasApprove}
        setShowAvaliableCandidate={setShowAvaliableCandidate}
        respostasQuestionarioStartup={respostasQuestionarioStartup}
      />
    );
  }

  if (cpfSearched) {
    return (
      <BaSeDataTable
        singularItemDescription="candidato"
        pluralItemDescription="candidatos"
        genderOfItemDescription="male"
        config={configTable}
        columnConfig={columnConfig}
        fetchData={loadSEarchInterview}
        backgroundColor={BaSeTheme.colors.defaultColors.white}
        foregroundColor={BaSeTheme.colors.institucionais.cinzaSebrae60}
        highlightedColor={BaSeTheme.colors.institucionais.cinzaSebrae30}
        separatorColor={BaSeTheme.colors.institucionais.cinzaSebrae90}
        filterAreaBackgroundColor={BaSeTheme.colors.defaultColors.white}
        hasPagination
        hasSorting
        hasSelection
        hasCustomFilter
        textFilterAlwaysVisible
        customFilterIconVisible={false}
        customFilterVisible={hasCustomFilter}
        initialPageSize={10}
        isLoading={loadingSearch}
        items={dataSearchInterview.items}
        total={dataSearchInterview.total}
        title=""
        initialSortType="DESC"
        initialSortField="interviewDate"
        hasTextFilter
        textFilterWidth={345}
        textFilterPlaceholder={`Pesquisar por nome, e-mail, CPF e telefone`}
        textFilterInitialValue={cpfSearched}
        onTextFilter={({ setFilter, term }) => {
          if (cpfSearched !== term) {
            clear()
          }
          setFilter((currentFilter) => ({
            ...currentFilter,
            ufs: [],
            fieldOfResearch: cpfSearched,
          }));
        }}
        configActionItemsProps={{ icon: 'ellipsis-v' }}
        selectionIconActions={({ isAllSelected, selectedItems }) =>
          getSelectionIconActions(isAllSelected, selectedItems)
        }
        renderCustomFilter={({ setFilter }) => buildCustomFilter(setFilter)}
        selectionButtonActions={({
          isAllSelected,
          selectedItems,
          reloadData,
        }) => {
          setItemsSelectTable(selectedItems);
          setIsAllSelect(isAllSelected);
          return [];
        }}
        onClearFilter={() => {
          clearSearchInterview();
        }}
      />
    );
  }

  if (moduleSelected?.id === 4) {
    return (
      <RuralTable
        configTable={configTable}
        columnConfig={columnConfig}
        cache={cache}
        cacheKeySebrae={cacheKeySebrae}
        data={data}
        loading={loading}
        buildCustomFilter={buildCustomFilter}
        fetchData={fetchData}
        clearAll={clearAll}
        getSelectionButtonActions={getSelectionButtonActions}
        getSelectionIconActions={getSelectionIconActions}
        hasCustomFilter={hasCustomFilter}
        setItemsSelectTable={setItemsSelectTable}
        setIsAllSelect={setIsAllSelect}
        textFilter={textFilter}
      />
    );
  }
  return (
    <CommonTable
      configTable={configTable}
      columnConfig={columnConfig}
      cache={cache}
      cacheKeySebrae={cacheKeySebrae}
      data={data}
      loading={loading}
      buildCustomFilter={buildCustomFilter}
      fetchData={fetchData}
      clearAll={clearAll}
      getSelectionButtonActions={getSelectionButtonActions}
      getSelectionIconActions={getSelectionIconActions}
      hasCustomFilter={hasCustomFilter}
      setItemsSelectTable={setItemsSelectTable}
      setIsAllSelect={setIsAllSelect}
      textFilter={textFilter}
    />
  );
};

export default MainContent;
